import {
  CLOSE_BUTTON,
  MENU,
  MENU_ITEM_DATA_PRIVACY,
} from "../../constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
import { observer } from "mobx-react";
import Modal from "../Modal/Modal";
import SizedBox from "../SizedBox/SizedBox";
import { useHistory } from "react-router-dom";
import { DATA_PRIVACY, HISTORY } from "../../constants/routes";
import './Menu.scss';
import supervisorStore from "../../stores/SupervisorStore";

type Props = {
  onClose(): void;
};

const Menu: React.FC<Props> = ({ onClose }) => {
  const translations = translationsStore.translations;
  const history = useHistory();
  const goToDataPrivacy = () => {
    console.log("Going to privacy...");
    history.push(DATA_PRIVACY);
  };

  return (
    <Modal onClose={onClose} showCloseButton>
      <h2>{translations[MENU]}</h2>
      <div className="version">v {process.env.REACT_APP_VERSION}</div>

      <SizedBox height={40} />
      <div className='menu'>
        <h4 onClick={goToDataPrivacy}>{translations[MENU_ITEM_DATA_PRIVACY]}</h4>
        {supervisorStore.supervisor && <h4 onClick={() => history.push(HISTORY)}>Validations history</h4>}
      </div>
      <SizedBox height={40} />
      <button className={`button filled-button`} onClick={onClose}>
        {translations[CLOSE_BUTTON]}
      </button>
    </Modal>
  );
};

export default observer(Menu);
